/* Bridgewater Direct: Real Installations photo viewer (snippets/bd-install-photos.liquid).
   Native <dialog>, no library. Full-size photos load only when the viewer opens (plus the
   neighbours of the one on screen). Previous / next, arrow keys, Esc, swipe, and tap or
   click to zoom (the zoomed photo pans by scrolling or dragging). Closing hands focus back
   to the thumbnail and leaves the page, and the configurator, exactly where they were. */
(function () {
  'use strict';

  function lightbox(items) {
    let i = 0, zoomed = false, lastFocus = null, sx = 0, sy = 0, swiping = false;
    const dlg = document.createElement('dialog');
    dlg.className = 'bd-ig-lb';
    dlg.setAttribute('aria-label', 'Installation photographs');
    dlg.innerHTML =
      '<div class="bd-ig-lb__bar">' +
        '<span class="bd-ig-lb__count" aria-live="polite"></span>' +
        '<button type="button" class="bd-ig-lb__btn bd-ig-lb__zoom" aria-pressed="false">Zoom</button>' +
        '<button type="button" class="bd-ig-lb__btn bd-ig-lb__close" aria-label="Close photographs">&times;</button>' +
      '</div>' +
      '<div class="bd-ig-lb__stage">' +
        '<button type="button" class="bd-ig-lb__nav bd-ig-lb__nav--prev" aria-label="Previous photograph">&#8249;</button>' +
        '<div class="bd-ig-lb__frame"><img class="bd-ig-lb__img" alt="" decoding="async" draggable="false"></div>' +
        '<button type="button" class="bd-ig-lb__nav bd-ig-lb__nav--next" aria-label="Next photograph">&#8250;</button>' +
      '</div>' +
      '<p class="bd-ig-lb__cap"></p>';
    document.body.appendChild(dlg);
    const img = dlg.querySelector('.bd-ig-lb__img');
    const frame = dlg.querySelector('.bd-ig-lb__frame');
    const count = dlg.querySelector('.bd-ig-lb__count');
    const cap = dlg.querySelector('.bd-ig-lb__cap');
    const zoomBtn = dlg.querySelector('.bd-ig-lb__zoom');
    const many = items.length > 1;
    dlg.querySelectorAll('.bd-ig-lb__nav').forEach(b => { b.hidden = !many; });

    const preload = k => { const it = items[(k + items.length) % items.length]; if (it && !it.pre) { it.pre = new Image(); it.pre.srcset = it.srcset; it.pre.sizes = '100vw'; it.pre.src = it.src; } };

    function setZoom(on, px, py) {
      zoomed = on && !!img.naturalWidth;
      dlg.classList.toggle('is-zoomed', zoomed);
      zoomBtn.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
      zoomBtn.textContent = zoomed ? 'Fit' : 'Zoom';
      if (zoomed) {
        // Keep the point that was clicked under the pointer.
        const r = frame.getBoundingClientRect();
        const fx = px == null ? 0.5 : (px - r.left) / r.width, fy = py == null ? 0.5 : (py - r.top) / r.height;
        requestAnimationFrame(() => {
          frame.scrollLeft = fx * frame.scrollWidth - r.width / 2;
          frame.scrollTop = fy * frame.scrollHeight - r.height / 2;
        });
      } else { frame.scrollLeft = 0; frame.scrollTop = 0; }
    }
    function show(k) {
      i = (k + items.length) % items.length;
      const it = items[i];
      setZoom(false);
      img.removeAttribute('src');
      img.sizes = '100vw';
      img.srcset = it.srcset;
      img.src = it.src;
      img.alt = it.alt;
      if (it.w && it.h) { img.width = it.w; img.height = it.h; }
      count.textContent = `${i + 1} / ${items.length}`;
      cap.textContent = it.alt;
      if (many) { preload(i + 1); preload(i - 1); }
    }
    function open(k, from) {
      lastFocus = from || document.activeElement;
      show(k);
      document.documentElement.classList.add('bd-ig-open');
      dlg.showModal();
    }
    dlg.addEventListener('close', () => {
      document.documentElement.classList.remove('bd-ig-open');
      setZoom(false);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    });

    dlg.querySelector('.bd-ig-lb__close').addEventListener('click', () => dlg.close());
    dlg.querySelector('.bd-ig-lb__nav--prev').addEventListener('click', () => show(i - 1));
    dlg.querySelector('.bd-ig-lb__nav--next').addEventListener('click', () => show(i + 1));
    zoomBtn.addEventListener('click', () => setZoom(!zoomed));
    // Clicking the backdrop (outside the photo and controls) closes.
    dlg.addEventListener('click', e => { if (e.target === dlg || e.target.classList.contains('bd-ig-lb__stage')) dlg.close(); });
    dlg.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight' && many) { e.preventDefault(); show(i + 1); }
      else if (e.key === 'ArrowLeft' && many) { e.preventDefault(); show(i - 1); }
    });
    // Tap / click the photo to zoom in at that point, and again to fit.
    img.addEventListener('click', e => { if (!swiping) setZoom(!zoomed, e.clientX, e.clientY); });
    // Swipe between photos when not zoomed (zoomed, a drag pans instead).
    frame.addEventListener('pointerdown', e => { sx = e.clientX; sy = e.clientY; swiping = false; if (zoomed && e.pointerType === 'mouse') { frame.setPointerCapture(e.pointerId); frame.dataset.drag = `${e.clientX},${e.clientY},${frame.scrollLeft},${frame.scrollTop}`; } });
    frame.addEventListener('pointermove', e => {
      if (!frame.dataset.drag) return;
      const [x, y, l, t] = frame.dataset.drag.split(',').map(Number);
      frame.scrollLeft = l - (e.clientX - x); frame.scrollTop = t - (e.clientY - y);
      if (Math.abs(e.clientX - x) + Math.abs(e.clientY - y) > 6) swiping = true;
    });
    const endDrag = () => { delete frame.dataset.drag; setTimeout(() => { swiping = false; }, 0); };
    frame.addEventListener('pointerup', e => {
      if (!zoomed && many) {
        const dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) { swiping = true; show(dx < 0 ? i + 1 : i - 1); }
      }
      endDrag();
    });
    frame.addEventListener('pointercancel', endDrag);
    return { open };
  }

  function mount(el) {
    if (el.__bdIg) return;
    el.__bdIg = true;
    const thumbs = Array.from(el.querySelectorAll('.bd-ig__thumb'));
    if (!thumbs.length || typeof HTMLDialogElement !== 'function') return;   // the links still open the photos
    const items = thumbs.map(a => {
      const im = a.querySelector('img');
      return { src: a.dataset.igSrc || a.href, srcset: a.dataset.igSrcset || '', alt: (im && im.alt) || '', w: +a.dataset.igW || 0, h: +a.dataset.igH || 0 };
    });
    let lb = null;
    el.addEventListener('click', e => {
      const t = e.target.closest('[data-ig-open]');
      if (!t || !el.contains(t)) return;
      if (e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;   // let "open in new tab" work
      e.preventDefault();
      lb = lb || lightbox(items);
      lb.open(+t.dataset.igOpen || 0, t);
    });
  }

  const run = () => document.querySelectorAll('[data-bd-ig]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.BDInstallGallery = { mount };
})();
